// extracted by mini-css-extract-plugin
export default {"centerText":"zDMIhYFEBKD89wmyRg9d","wrapper":"yBexp3K6pee2z3u5pRAk"};